export default {
  '/': function* () {
    console.log('saga-router is works!')
  }
}



// WEBPACK FOOTER //
// app/javascript/src/sagas/routes.js